$(document).ready(function () {
  $(document).on("swell:referral:success", function () {
    getreferrals();
  });

  $("body").on("click", ".swell-share-referral-copy", function () {
    setTimeout(function () {
      $(".swell-referral-copy-link").html($(".swell-referral-copy-link").html() + "?c");
    }, 20);
  });

  $(document).on("swell:referral:error", function (jqXHR, textStatus, errorThrown) {
    if (textStatus && textStatus === "EMAILS_ALREADY_PURCHASED") {
      $(".refer-customer-error").remove();
      $(".swell-referral-form-body").prepend('<p class="refer-customer-error">Sorry! Looks like this person has already made a purchase. Try referring another friend.</p>');
      $("#swell-referral-refer-emails").addClass("error-border");
    }
    if (textStatus && textStatus === "Please enter a valid email address") {
      $(".refer-customer-error").remove();
      $(".swell-referral-form-body").prepend('<p class="refer-customer-error">Please enter valid email addresses seperated with commas</p>');
      $("#swell-referral-refer-emails").addClass("error-border");
    }
  });

  $(document).on("swell:initialized", function () {
    $('.swell-referral-loader').hide();
    var campaigns = spapi.activeCampaigns;
    campaigns.forEach(function (camp) {
      if (camp.type != "ReferralCampaign") {
        if (camp.id == "555122") {
          $(".swell-campaign-list").append('<li class="swell-campaign"> <div class="swell-campaign-content swell-campaign-link" data-display-mode="modal" data-campaign-id=' + camp.id + '> <div class="swell-campaign-icon"> <span class="swell-campaign-icon-content"> <span class=' + camp.icon + '><span class="path1"></span><span class="path2"></span></span></span> </div> <div class="swell-campaign-value"> <span class="swell-campaign-value-content">' + camp.title + '</span> </div> <div class="swell-campaign-type"> <span class="swell-campaign-type-content">' + camp.reward_text + '</span> </div> </div> </li>');
        } else {
          $(".swell-campaign-list").append('<li class="swell-campaign"> <div class="swell-campaign-content swell-campaign-link" data-display-mode="modal" data-campaign-id=' + camp.id + '> <div class="swell-campaign-icon"> <span class="swell-campaign-icon-content"> <span class=' + camp.icon + '><span class="path1"></span><span class="path2"></span></span></span> </div> <div class="swell-campaign-value"> <span class="swell-campaign-value-content">' + camp.reward_text + '</span> </div> <div class="swell-campaign-type"> <span class="swell-campaign-type-content">' + camp.title + '</span> </div> </div> </li>');
        }
      }
    });
  });

  $(document).on("swell:setup", function () {
    $(".box-of-style-rewards .swell-post-checkout").css("display", "flex");
    $(".box-of-style-rewards .swell-post-checkout .checkout-heading .swell-referral-back-link, .swell-cross-checkout").click(function () {
      $(".box-of-style-rewards .swell-post-checkout").css("display", "none");
    });
    $('.swell-referral-loader-refer').hide();
    Swell.Referral.initializeReferral(".swell-referral-referpage", SwellConfig.referReferral.opts);
    if (spapi.authenticated) {
      getreferrals();
    }
    var clipboard = new Clipboard("#swell-referral-copy-btn");
  });
});

function getreferrals() {
  $('.table-data').html("");
  var count = 0;
  swellAPI.refreshCustomerDetails(function () {
    var recep = spapi.customer.referral_receipts;
    recep.forEach(function (rec) {
      var em = rec.email;
      var stat = rec.completed_at;
      if (stat) {
        $('.table-data').append("<tr> + <td>" + rec.email + "</td> <td> Purchased ($25 earned) </td> </tr>");
        count++;
      } else {
        $('.table-data').append("<tr> + <td>" + rec.email + "</td> <td> Invited </td> </tr>");
      }
    });
    $(".swell-refer-earning").html(count * 25);
  });
};
